import { useState } from 'react';

import { usePublicCalculatorContext } from '~src/context/PublicCalculatorContext';
import { useNewOfferPriceWithExpenses } from '~src/hooks/useNewOfferPriceWithExpenses';
import { findBestCompatibleIndoorUnit, formatProductText } from '~src/util';

import { ProductCardCommonNorlys } from './components/ProductCardCommon';
import { ProductContentCommonNorlys } from './components/ProductContentCommon';
import { HeatPumpCardProps, ProductContentProps } from './types';
import { formatHeatPumpInfoRows } from './util';

export const HeatPumpCardNorlys = ({ selected, heatPumpOffer, height = 200, ...rest }: HeatPumpCardProps) => {
  const { newOfferExpenses, indoorUnits } = usePublicCalculatorContext();

  const [flipped, setFlipped] = useState(false);

  const { heatPumpOutdoorUnit } = heatPumpOffer;

  const productLabel = formatProductText(heatPumpOutdoorUnit);

  const indoorUnit = findBestCompatibleIndoorUnit(heatPumpOutdoorUnit, indoorUnits);

  const expensesPrice = useNewOfferPriceWithExpenses(heatPumpOffer, newOfferExpenses);

  const price = (heatPumpOutdoorUnit?.price ?? 0) + expensesPrice + (indoorUnit?.price ?? 0);

  return (
    <ProductCardCommonNorlys {...{ selected, productLabel, flipped, setFlipped, price, ...rest }}>
      <HeatPumpContentNorlys {...{ selected, height, heatPump: heatPumpOutdoorUnit, flipped }} />
    </ProductCardCommonNorlys>
  );
};

const HeatPumpContentNorlys = ({ selected, height, heatPump, flipped }: ProductContentProps) => {
  if (!heatPump) {
    return null;
  }

  const infoRows = formatHeatPumpInfoRows(heatPump);

  return (
    <ProductContentCommonNorlys
      {...{
        selected,
        flipped,
        height,
        imageUrl: heatPump.imageUrl,
        infoRows,
      }}
    />
  );
};
